export const DeviceTypeEnum = {
    CALYX_Y: 'CALYX_Y',
    WATER_METER: 'WATER_METER',
    SCALE: 'SCALE',
}